import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "./Logo";

const LIVE_CLASSES_ID = "live-classes";
const LIVE_CLASSES_HASH = `#${LIVE_CLASSES_ID}`;

const scrollToLiveClasses = () => {
  const section = document.getElementById(LIVE_CLASSES_ID);
  if (!section) return;
  section.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (location.pathname !== "/" || location.hash !== LIVE_CLASSES_HASH) return undefined;
    const frame = window.requestAnimationFrame(scrollToLiveClasses);
    const timer = window.setTimeout(scrollToLiveClasses, 120);
    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(timer);
    };
  }, [location.pathname, location.hash]);

  const handleLiveClasses = () => {
    if (location.pathname === "/" && location.hash === LIVE_CLASSES_HASH) {
      scrollToLiveClasses();
      return;
    }
    navigate({ pathname: "/", hash: LIVE_CLASSES_HASH });
  };

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 transition-all duration-300"
      style={{
        background: scrolled ? "rgba(253,251,246,0.88)" : "transparent",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        borderBottom: scrolled
          ? "1px solid rgba(32,24,80,0.08)"
          : "1px solid transparent",
      }}
    >
      <div className="mx-auto max-w-7xl px-3 sm:px-6 md:px-10 h-24 flex items-center justify-between gap-2">
        <Link to="/" aria-label="BotsPay.me home">
          <Logo height="clamp(54px, 8vw, 90px)" />
        </Link>
        <div className="flex items-center gap-2 sm:gap-3">
          <button
            type="button"
            onClick={handleLiveClasses}
            aria-controls={LIVE_CLASSES_ID}
            className="header-pill btn-lift inline-flex items-center gap-1.5 sm:gap-2 px-3 py-2 sm:px-5 sm:py-2.5 text-xs sm:text-sm font-semibold rounded-full"
            style={{
              background: "#ffffff",
              color: "#201850",
              border: "1px solid rgba(32,24,80,0.2)",
              boxShadow: "0 4px 14px rgba(32,24,80,0.06)",
            }}
            data-testid="live-classes-btn"
          >
            Live Classes
            <span aria-hidden="true" className="text-sm leading-none" style={{ color: "#00A8E8" }}>↓</span>
          </button>
          <button
            type="button"
            onClick={() => navigate("/get-started")}
            className="header-pill btn-lift inline-flex items-center gap-2 px-3 py-2 sm:px-5 sm:py-2.5 text-xs sm:text-sm font-semibold rounded-full"
            style={{
              background: "rgba(255,255,255,0.88)",
              color: "#9A6E1C",
              border: "1px solid #C69A3A",
              boxShadow: "0 4px 14px rgba(198,154,58,0.1)",
            }}
            data-testid="header-setup-guide-button"
          >
            Setup Guide
          </button>
        </div>
      </div>
    </header>
  );
}
